import { render, staticRenderFns } from "./NotionQueryBlock.vue?vue&type=template&id=4e8cd2ff"
import script from "./NotionQueryBlock.vue?vue&type=script&lang=js"
export * from "./NotionQueryBlock.vue?vue&type=script&lang=js"
import style0 from "./NotionQueryBlock.vue?vue&type=style&index=0&id=4e8cd2ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports